"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = void 0;
const cbor_1 = __importDefault(require("cbor"));
exports.Base = {
    _namespace_: "base",
    async endpoints() {
        const msg = await this.call("endpoints");
        return await getEndpoints(msg);
    },
    async heartbeat() {
        const res = await this.call("heartbeat");
        return res.getPayload();
    },
    async status() {
        const msg = await this.call("status");
        return await getNetworkStatus(msg);
    },
};
async function getNetworkStatus(msg) {
    var _a;
    const result = {
        status: undefined,
    };
    const content = msg.getPayload();
    if (content instanceof Map) {
        const publicKey = content.has(2) ? cbor_1.default.decode(content.get(2)) : null;
        result.status = {
            protocolVersion: content.get(0),
            serverName: content.get(1),
            publicKey,
            address: (_a = content.get(3)) === null || _a === void 0 ? void 0 : _a.toString(),
            attributes: content.get(4),
            serverVersion: content.get(5),
            timeDeltaInSecs: content.get(7),
        };
    }
    return result;
}
async function getEndpoints(msg) {
    const result = {
        endpoints: [],
    };
    const content = msg.getPayload();
    if (Array.isArray(content)) {
        result.endpoints = content;
    }
    return result;
}
